import { Button, Card, CardActionArea, CardActions, CardContent, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";
import CustomerBirthday from "../atoms/CustomerBirthday";
import CustomerName from "../atoms/CustomerName";
import MembershipCode from "../atoms/MembershipCode";

export interface CustomerCardProps {
    customer: CustomerInterface
    onClick?: (customer: CustomerInterface) => void | undefined
    footMenu?: React.ReactNode
    additionalContent?: React.ReactNode
}

const CustomerCard: React.FC<CustomerCardProps> = ({
    customer,
    onClick,
    footMenu,
    additionalContent
}) => {
    let { enqueueSnackbar } = useSnackbar()

    let content = (
        <CardContent>
            {customer.delete_flug=="1" &&
                <Typography variant="body2" color="error">抹消済みユーザー</Typography>
            }
            <MembershipCode customerData={customer} />
            <CustomerName customerData={customer} />
            <CustomerBirthday customerData={customer} />
            {additionalContent}
        </CardContent>
    )

    return (
        <Card variant="outlined" className={customer.delete_flug=="1" ? "disabledCard" : undefined}>
            {onClick ? (
                <CardActionArea
                    onClick={() => {
                        if (onClick) {
                            onClick(customer)
                        }
                    }}
                >{content}</CardActionArea>
            ) : (content)}
            {footMenu}
        </Card>
    )
}

export default CustomerCard